/* KnowledgeCardMedia.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./KnowledgeCardMedia.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
var knowledgeCardMediaStyles = {
  default: "_2rko12b0 _189eidpf _1e0c1txw _4cvr1h6o",
  compact: "_4t3izwfg _1bsbzwfg",
  full: "_4t3iys9h _1bsbys9h"
};
export var KnowledgeCardMedia = function KnowledgeCardMedia(_ref) {
  var children = _ref.children,
    size = _ref.size;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: cx(knowledgeCardMediaStyles.default, size === 'compact' ? knowledgeCardMediaStyles.compact : knowledgeCardMediaStyles.full)
  }, children);
};